import { Code, ConnectError, createPromiseClient } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import { AggregateAPI } from "proto/aggregate/v1/aggregate_api_connect";
import { AuthAPI } from "proto/auth/v1/auth_connect";
import { UserAPI } from "proto/user/v1/user_api_connect";
import { apiPath } from "server-props";

export const transport = createConnectTransport({
  baseUrl: apiPath,
  credentials: "include",
  interceptors: [
    (next) => async (request) => {
      // Add your headers here
      try {
        const resp = await next(request);
        console.log({ resp });
        return resp;
      } catch (error) {
        if (
          error instanceof ConnectError &&
          error.code === Code.Unauthenticated
        ) {
          window.location.reload();
        }
        console.log("transaport error", { error });
        throw error;
      }
    },
  ],
});

export const transportWithoutInterceptors = createConnectTransport({
  baseUrl: apiPath,
  credentials: "include",
});

export const userAPIClient = createPromiseClient(UserAPI, transport);
export const authAPIClient = createPromiseClient(
  AuthAPI,
  transportWithoutInterceptors,
);

export const aggAPIClient = createPromiseClient(AggregateAPI, transport);
